<script>
    import jQuery from "jquery";
    export let message;
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-lostchangeswarning");

   export function open(nextAction) {
        jQuery('#GPLostChangesWarning').modal({});
        jQuery('#GPLostChangesConfirm').off('click').on('click',function() {jQuery('#GPLostChangesWarning').one('hidden.bs.modal', nextAction);});
        jQuery('#GPLostChangesWarning').on('hidden.bs.modal', () => this.$destroy())

       //trap focus
        jQuery('#GPLostChangesWarning').on('shown.bs.modal',function (){jQuery('#GPLostChangesDismiss').focus();});
        jQuery('#GPLostChangesWarning .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
        jQuery('#GPLostChangesConfirm').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});
   }
</script>

<div class="modal fade GPModal" id="GPLostChangesWarning">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans("Unsaved changes will be lost")}. {trans("Are you sure")}?</h4>
            </div>
            {#if message}
                <div class="modal-body">
                    {message}
                </div>
            {/if}
            <div class="modal-footer">
                <button id="GPLostChangesDismiss" type="button" class="btn btn-default" data-dismiss="modal">{trans("Cancel")}</button>
                <button id="GPLostChangesConfirm" type="button" class="btn btn-primary" data-dismiss="modal">{trans("Yes")}</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->